import { apiClient } from './setupApi';

export const logIn = async (payload) => {
  const { data } = await apiClient.post('/auth/login', payload);
  return data;
};

export const resetPassword = async (payload) => {
  const { data } = await apiClient.post('/auth/reset-password', payload);
  return data;
};

export const requestLogOut = async () => {
  const { data } = await apiClient.get('/auth/logout');
  return data;
};

export const ConfirmResetPassword = async (payload) => {
  const { data } = await apiClient.post('/auth/confirm-reset-password', payload);
  return data;
};

export const ConfirmRegistration = async (payload) => {
  const { data } = await apiClient.post('/auth/confirm-registration', payload);
  return data;
};
